module.exports = __webpack_public_path__ + "img/marchio.4bca1874.png";